import { Component, ErrorInfo } from 'react';
import logger from '../services/logger-service';

interface Props {
  children: JSX.Element;
}

interface State {
  hasError: boolean;
  error: string;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: '' };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // log to greylog
    if (process.env.NODE_ENV?.trim() === 'development') {
      logger.error('Uncaught error log: ', error, info);
    }

    this.setState((prev) => ({
      ...prev,
      error: JSON.stringify(`${error}, ${info}`, null, 2),
    }));
  }

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <p>{error}</p>;
    }

    return children;
  }
}

export default ErrorBoundary;
